import _ from 'lodash';
import ProfileStore from '../stores/ProfileStore';
import mapping from 'arbitrip-common/theme/mapping';
import { COMPANY_NAME } from 'arbitrip-common/theme/constants';

const isCompany = (companyName) => {
    const companyNameFromHostname = mapping.getCompanyNameFromHostname();
    if (companyNameFromHostname === companyName) {
        return true;
    }

    const profile = ProfileStore.getProfile();
    const companyId = _.get(profile, 'company.id');
    return mapping[companyId] === companyName;
};

export const isElalCompany = () => isCompany(COMPANY_NAME.ELAL);
export const isIsracardCompany = () => isCompany(COMPANY_NAME.ISRACARD);
export const isAirHaifaCompany = () => isCompany(COMPANY_NAME.AIRHAIFA);
